export default "__VITE_ASSET__1a5ea37f__"